<template>
  <!--<div class="layout-seat"-->
       <!--:class="{ 'regular-seat': regHoverEffect, 'vip-seat': vipHoverEffect, 'recliner-seat': recHoverEffect, 'wheelchair-seat': whcHoverEffect, 'sofa-seat': sofaHoverEffect, 'companion-seat': cmpHoverEffect, 'broken-seat': bknHoverEffect, 'disabled': disabledSeatClass, 'elevation-6': elevateSeat, 'reposition-seat' : repositionBooking, 'reposition-hint' : repositionHint }"-->
  <div class="layout-seat"
       :class="{
          'disabled': disabledSeatClass,
          'elevation-6': elevateSeat,
          'reposition-seat' : repositionBooking,
          'reposition-hint' : repositionHint,
          'happy-seat' : mySeat.managerReserved
       }"
       :style="{
          'top': top,
          'left': left,
          'height': seatHeight,
          'width': seatWidth,
          'border': 'solid 2px ' + seatBorderColor,
          'background': seatBG,
          'border-style': borderStyle
       }"
       :data-seat_id="mySeat.id"
       @contextmenu="showContextMenu($event)"
       @click="seatClicked($event)"
       @click.ctrl="seatAddedToSelection($event)"
       @mousedown="triggerEnableEditMode('mouse-click')"
       @touchstart="triggerEnableEditMode('screen-touch')"
  >
    <!--
        @mousedown="multiSlotMoveOrigin"
       @touchstart="multiSlotMoveOrigin"
       @mouseup="multiSlotMoveDestination"
       @touchend="multiSlotMoveDestination"
    -->

    <p class="layout-seat-name subheading text-xs-center"
       slot="activator"
       :style="{ 'margin-top': titleMarginTop }"
    >
      <template v-if="scoreView">
        <span class="caption" :style="{ 'color': textColor }">{{ mySeat.slotScore }}</span>
      </template>
      <template v-else>
        <span class="caption" v-if="showSeatText" :style="{ 'color': textColor }">{{ seatInnerTitle }}</span>
        <v-icon v-else :color="iconColor">{{ seatInnerTitle }}</v-icon>
      </template>
    </p>

    <!--
    <v-tooltip v-if="bookingMode" bottom>
      <p class="layout-seat-name subheading text-xs-center"
         slot="activator"
         :style="{ 'margin-top': titleMarginTop }"
      >
        <template v-if="scoreView">
          <span class="caption" :style="{ 'color': textColor }">{{ mySeat.slotScore }}</span>
        </template>
        <template v-else>
          <span class="caption" v-if="showSeatText" :style="{ 'color': textColor }">{{ seatInnerTitle }}</span>
          <v-icon v-else :color="iconColor">{{ seatInnerTitle }}</v-icon>
        </template>
      </p>
      <p class="text-xs-center mb-0">{{ seatTooltipTitle }}</p>
      <span v-if="isBrokenSeat && strRepairStartDate && strRepairEndDate"> <i>{{ strRepairStartDate }} - {{ strRepairEndDate }}</i></span>
    </v-tooltip>
    <p v-else
       class="layout-seat-name subheading text-xs-center"
       slot="activator"
       :style="{ 'margin-top': titleMarginTop }"
    >
      <span class="caption" v-if="showSeatText" :style="{ 'color': textColor }">{{ seatInnerTitle }}</span>
      <v-icon v-else :color="iconColor">{{ seatInnerTitle }}</v-icon>
    </p>
    -->
  </div>
</template>

<script>
  import pep from 'jquery.pep.js/src/jquery.pep';
  import moment from 'moment';

  export default {
    name: "Seat",

    props: {
      mySeat: Object,
      bookingMode: Boolean,
      reserved: Boolean,
      booked: Boolean,
      repositionBooking: Boolean,
      repositionHint: Boolean,
      scoreView: Boolean,
      editSelected: Boolean
    },

    data: () => ({
      seatHeight: '26px', //36px
      iconColor: '',

      disabledBColour: '#E0E0E0',
      disabledTColour: '#9E9E9E',
      disabledIColour: 'grey',
      flashingColor: 1
    }),

    computed: {
      seatWidth() {
        let width;
        if (this.mySeat.capacity === 1) {
          width = '36px'; //56px
        } else if (this.mySeat.capacity === 2) {
          width = '44px'; //84px
        }
        return width;
      },
      top() {
        return this.mySeat.y + 'px';
      },
      left() {
        return this.mySeat.x + 'px';
      },
      seatInnerTitle() {
        let title;
        if (this.isBrokenSeat) {
          title = 'build';
        } else if (this.mySeat.slotCategory.id === this.SLOT_CATEGORY_VIP) {
          title = 'star';
        } else if (this.mySeat.slotCategory.id === this.SLOT_CATEGORY_WHEELCHAIR) {
          title = 'accessible';
        } else if (this.mySeat.slotCategory.id === this.SLOT_CATEGORY_RECLINER) {
          title = 'airline_seat_recline_extra';
        } else {
          title = (this.mySeat.rowLabel !== '' || this.mySeat.slotNumber !== '') ? this.mySeat.rowLabel + this.mySeat.slotNumber : 'New';
        }
        return title;
      },
      seatTooltipTitle() {
        return this.mySeat.rowLabel +  '-' + this.mySeat.slotNumber;
      },
      titleMarginTop() {
        return (this.mySeat.slotCategory.id === this.SLOT_CATEGORY_REGULAR) ? '-2px' : '-2px'; // 5px  3px
      },
      borderColor() {
        let sColor = 'black';
        this.iconColor = 'black';
        if (this.isBrokenSeat) {
          sColor = '#FFCDD2';
          this.iconColor = 'red lighten-4';
        } else if (this.mySeat.slotCategory.id === this.SLOT_CATEGORY_REGULAR && this.mySeat.capacity === 1) {
          sColor = (this.booked) ? this.disabledBColour : '#4E342E';
          this.iconColor = (this.booked) ? this.disabledIColour : ((this.reserved) ? 'white' : 'brown darken-3');
        } else if (this.mySeat.slotCategory.id === this.SLOT_CATEGORY_VIP && this.mySeat.capacity === 1) {
          // sColor = (this.booked) ? this.disabledBColour : '#2979FF';
          sColor = (this.booked) ? this.disabledBColour : '#FF6D00';
          // this.iconColor = (this.booked) ? this.disabledIColour : ((this.reserved) ? 'white' : 'blue accent-3');
          this.iconColor = (this.booked) ? this.disabledIColour : ((this.reserved) ? 'white' : 'orange accent-4');
        } else if (this.mySeat.slotCategory.id === this.SLOT_CATEGORY_RECLINER && this.mySeat.capacity === 1) {
          sColor = (this.booked) ? this.disabledBColour : '#B388FF';
          this.iconColor = (this.booked) ? this.disabledIColour : ((this.reserved) ? 'white' : 'deep-purple accent-1');
        } else if (this.mySeat.slotCategory.id === this.SLOT_CATEGORY_WHEELCHAIR && this.mySeat.capacity === 1) {
            // sColor = (this.booked) ? this.disabledBColour : '#FF6D00';
            sColor = (this.booked) ? this.disabledBColour : '#2979FF';
            // this.iconColor = (this.booked) ? this.disabledIColour : ((this.reserved) ? 'white' : 'orange accent-4');
            this.iconColor = (this.booked) ? this.disabledIColour : ((this.reserved) ? 'white' : 'blue accent-3');
        } else if (this.mySeat.slotCategory.id === this.SLOT_CATEGORY_COMPANION && this.mySeat.capacity === 1) {
            sColor = (this.booked) ? this.disabledBColour : '#FDD835';
            this.iconColor = (this.booked) ? this.disabledIColour : ((this.reserved) ? 'white' : 'yellow darken-1');
        } else if (this.mySeat.capacity === 2) {
          sColor = (this.booked) ? this.disabledBColour : '#9E9D24';
          this.iconColor = (this.booked) ? this.disabledIColour : ((this.reserved) ? 'white' : 'lime darken-3');
        }
        return sColor;
      },
      showSeatText() {
        return !this.isBrokenSeat && (this.mySeat.slotCategory.id === this.SLOT_CATEGORY_REGULAR || this.mySeat.slotCategory.id === this.SLOT_CATEGORY_COMPANION);
      },
      regHoverEffect() {
        return this.bookingMode && (! this.booked) && (this.mySeat.slotCategory.id === this.SLOT_CATEGORY_REGULAR && this.mySeat.capacity === 1);
      },
      vipHoverEffect() {
        return this.bookingMode && (! this.booked) && (this.mySeat.slotCategory.id === this.SLOT_CATEGORY_VIP && this.mySeat.capacity === 1);
      },
      recHoverEffect() {
        return this.bookingMode && (! this.booked) && (this.mySeat.slotCategory.id === this.SLOT_CATEGORY_RECLINER && this.mySeat.capacity === 1);
      },
      whcHoverEffect() {
        return this.bookingMode && (! this.booked) && (this.mySeat.slotCategory.id === this.SLOT_CATEGORY_WHEELCHAIR && this.mySeat.capacity === 1);
      },
      cmpHoverEffect() {
        return this.bookingMode && (! this.booked) && (this.mySeat.slotCategory.id === this.SLOT_CATEGORY_COMPANION && this.mySeat.capacity === 1);
      },
      sofaHoverEffect() {
        return this.bookingMode && (! this.booked) && (this.mySeat.capacity === 2);
      },
      bknHoverEffect() {
        return this.bookingMode && this.isBrokenSeat;
      },
      seatBG() {
        return (this.reserved) ? this.borderColor : '';
      },
      seatBorderColor() {
        return (this.repositionBooking || this.repositionHint) ? '#64FFDA' : this.borderColor;
      },
      textColor() {
        return (this.booked) ? this.disabledTColour : ((this.reserved) ? 'white' : this.borderColor);
      },
      disabledSeatClass() {
        return this.bookingMode && this.booked;
      },
      isBrokenSeat() {
        return this.mySeat.status === 'BROKEN'
      },
      elevateSeat() {
        return (!this.isBrokenSeat && !this.booked);
      },
      strRepairStartDate() {
        return (this.mySeat.repairStartDate) ? moment(this.mySeat.repairStartDate).format('DD MMM YYYY') : '';
      },
      strRepairEndDate() {
        return (this.mySeat.repairEndDate) ? moment(this.mySeat.repairEndDate).format('DD MMM YYYY') : '';
      },
      borderStyle() {
        return (!this.bookingMode && this.editSelected) ? 'dashed' : 'solid';
      }
    },

    methods: {
      showContextMenu(e) {
        this.$emit('show-seat-context-menu', e);
      },
      seatClicked(e) {
        if (this.bookingMode) {
          // this.reserved = true;
          // console.log('get here', this.mySeat);
          if (!this.isBrokenSeat && (! this.booked)) {
            this.$emit('seat-selected', e);
          }
        } else {
          this.$emit('show-seat-details', e);
        }
      },
      seatAddedToSelection(e) {
        if (! this.bookingMode) {
          this.$emit('add-seat-to-selection', e);
        }
      },
      triggerEnableEditMode(trigger) {
        if (this.bookingMode && this.reserved) {
          setTimeout(() => {
            this.$emit('enable-edit-mode', trigger);
          }, 300);
        }
      },
      /*
      multiSlotMoveOrigin() {
        if (this.bookingMode && this.reserved) {
          // setTimeout(() => {
            this.$emit('bulk-move-origin', this.mySeat);
          // }, 500);
        }
      },
      multiSlotMoveDestination() {
        setTimeout(() => {
          if (this.bookingMode && !this.reserved && !this.booked && this.mySeat.status !== 'BROKEN') {
            this.$emit('bulk-move-destination', this.mySeat);
          }
        }, 300);
      }
      */
    },

    mounted() {
      // console.log(this.iconColor);
      let self = this;

      // Initialize jquery.pep.js
      if (! this.bookingMode) {
        $(this.$el).pep({
          constrainTo: 'parent',
          useCSSTranslation: false,
          // start: function(ev,obj){ console.log("started!"); },
          // drag: function(ev,obj){ console.log("we're dragging!"); }, //seat_id: obj.el.dataset.seat_id,
          rest: function(ev,obj) {
            self.$emit('seat-moved', { x: obj.pos.x, y: obj.pos.y });
          }
        });
      }
    }
  }
</script>

<style scoped>
  .layout-seat {
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
  }
  .caption {
    font-weight: bold
  }
  /* Seats hover styling */
  .regular-seat:hover {
    cursor: pointer;
    background: #D7CCC8;
  }
  .vip-seat:hover {
    cursor: pointer;
    /*background: #BBDEFB;*/
    background: #FFE0B2;
  }
  .recliner-seat:hover {
    cursor: pointer;
    background: #D1C4E9;
  }
  .wheelchair-seat:hover {
    cursor: pointer;
    /*background: #FFE0B2;*/
    background: #BBDEFB;
  }
  .companion-seat:hover {
    cursor: pointer;
    background: #FFF9C4;
  }
  .sofa-seat:hover {
    cursor: pointer;
    background: #F0F4C3;
  }
  .broken-seat:hover {
    cursor: default;
    background: #FFEBEE;
  }

  .disabled {
    cursor: default;
    background: #E0E0E0;
  }

  /* Edit mode ribbon */
  .reposition-seat {
    width: 10em;
    height: 6em;
    position: relative;
  }
  .reposition-seat::before,
  .reposition-seat::after {
    content: '';
    position: absolute;
    top: -2px;
    right: -2px;
    border-color: transparent;
    border-style: solid;
  }
  /*.reposition-seat::before {*/
    /*border-width: 1.5em;*/
  /*}*/
  .reposition-seat::after {
    border-width: 0.55em;
    border-right-color: #64FFDA;
    border-top-color: #64FFDA;
  }

  /* Edit mode ribbon */
  .happy-seat {
    width: 10em;
    height: 6em;
    position: relative;
  }
  .happy-seat::before,
  .happy-seat::after {
    content: '';
    position: absolute;
    top: -2px;
    right: -2px;
    border-color: transparent;
    border-style: solid;
  }
  .happy-seat::after {
    border-width: 0.55em;
    border-right-color: #9E9E9E;
    border-top-color: #9E9E9E;
  }

  .reposition-hint {
    -webkit-animation: glowing 1500ms infinite;
    -moz-animation: glowing 1500ms infinite;
    -o-animation: glowing 1500ms infinite;
    animation: glowing 1500ms infinite;
  }

  @-webkit-keyframes glowing {
    0% { -webkit-box-shadow: 0 0 3px #64FFDA; }
    50% { -webkit-box-shadow: 0 0 20px #00BFA5; }
    100% { -webkit-box-shadow: 0 0 3px #64FFDA; }
  }

  @-moz-keyframes glowing {
    0% { -moz-box-shadow: 0 0 3px #64FFDA; }
    50% { -moz-box-shadow: 0 0 20px #00BFA5; }
    100% { -moz-box-shadow: 0 0 3px #64FFDA; }
  }

  @-o-keyframes glowing {
    0% { box-shadow: 0 0 3px #64FFDA; }
    50% { box-shadow: 0 0 20px #00BFA5; }
    100% { box-shadow: 0 0 3px #64FFDA; }
  }

  @keyframes glowing {
    0% { box-shadow: 0 0 3px #64FFDA; }
    50% { box-shadow: 0 0 20px #00BFA5; }
    100% { box-shadow: 0 0 3px #64FFDA; }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/Seat.vue